
import React, { useEffect } from "react";
import "mathlive"; // Import MathLive library

const MathLiveEdit = ({ onLatexChange }) => {
  useEffect(() => {
    const mathField = document.getElementById("mathfiled");

    if (mathField) {
      window.mathVirtualKeyboard.container = document.getElementById("keyboardcontainer");
      window.mathVirtualKeyboard.show();

      mathField.addEventListener("input", () => {
        const latex = mathField.getValue("latex");
        if (onLatexChange) {
          onLatexChange(latex); // Pass the updated LaTeX to the parent
        }
      });

      return () => {
        window.mathVirtualKeyboard.hide();
      };
    }
  }, [onLatexChange]);

  return (
    <div>
      <math-field id="mathfiled" style={{ width: "100%"}}></math-field>
      <div id="keyboardcontainer" style={{ height: "300px", width: "100%"  }}></div>
    </div>
  );
};

export default MathLiveEdit;
